module.exports = __webpack_public_path__ + "media/ButtonClick.99451f1f.mp3";